<template>
    <div class="tiny">
        <tiny :value="value" @input="$emit('input', $event)" :init="tinyInit"/>
    </div>
</template>

<script>
    import Tiny from '@tinymce/tinymce-vue'

    export default {

        components: { Tiny },

        props: {
            
            value: {
                type: String,
                default: null
            },

            height: {
                type: Number,
                default: 350
            }
        },

        computed: {

            tinyInit() {
                return {
                    height: this.height,
                    content_css : this.contentCss,
                    menubar: false,
                    plugins: [
                        'lists advlist table'
                    ],
                    toolbar:
                        'undo redo | formatselect | bold italic underline strikethrough superscript | forecolor backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | table | removeformat',
                    toolbar_mode: 'wrap',
                }
            },

            contentCss() {
                return this.$baseURL + '/css/plugins/tinymce/content.css'
            }
        },
    }
</script>

<style scoped>

    .tiny >>> .tox-tinymce {
        border: 1px solid #dee2e6;
    }
    .tiny >>> .tox-toolbar__primary {
        background-image: none;
        border-bottom: 1px solid #dee2e6;
    }
    .tiny >>> .tox-statusbar {
        border: none;
    }
    .tiny >>> .tox-statusbar__branding,
    .tiny >>> .tox-statusbar__text-container {
        display: none;
    }

</style>
